import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RequestModel } from 'src/app/typings/typing';
@Injectable({
  //作用域的设置：root表示默认注入到app.module里面去；null表示不设定区域，还可以是某个模块的名字（一般就是懒加载）
  providedIn: 'root'
})
export class PermissionManagementService {

  prefix = '/permission';

  constructor(private http: HttpClient) { }

  getPermissionList() {
    return this.http.get<RequestModel>(this.prefix + '/queryAll');
  }

  getPermissionByRole(roleId: number) {
    return this.http.get<RequestModel>(this.prefix + `/queryRolePermissions`, { params: { roleId } });
  }

  getTableList(params: any) {
    return this.http.post<RequestModel>(this.prefix + '/queryPage', params);
  }

  addOrUpdate(row: any) {
    if (row.id) {
      return this.http.put<RequestModel>(this.prefix + '/update', row);
    } else {
      return this.http.post<RequestModel>(this.prefix + '/save', row);
    }
  }

  delete(id: number | string) {
    return this.http.delete<RequestModel>(this.prefix + `/delete/${id}`);

  }

  getUserPermissionList() {
    return this.http.get<RequestModel>(this.prefix + '/queryUserPermissions');
  }
}
